import { MailboxesActionsType } from '@ukpostbox/client-data';
import { Button, ButtonGroup, ColourStateSolid, ContentLoader, Tooltip } from '@ukpostbox/frontend-framework';
import React, { memo } from 'react';
import { MailActionsIconMap } from '../../_Global/Data/MailActionsIconMap';
import { useMailbox } from '../Providers/NewMailboxProvider';

const MailActionButtons = memo((props: MailboxesActionsType) => {
	const { mailItemActionsStatus, selectionActions } = useMailbox();

	return mailItemActionsStatus === 'pending' ? (
		<ContentLoader childHeight='2.9em' childWidth='20em' childCount={1} round />
	) : selectionActions && selectionActions.length > 0 ? (
		<>
			{selectionActions &&
				selectionActions.map((action) =>
					action.name === 'Open and Scan' && !action.disabled ? (
						<Tooltip content={action.name} key={`action-${action.name}`}>
							<Button
								title={action.name}
								iconOnly={props.iconsOnly}
								icon={MailActionsIconMap[action.name]}
								colour={ColourStateSolid.Success}
								squared
								onClick={() =>
									props.actionCallback ? props.actionCallback(action.transitionId) : null
								}
							/>
						</Tooltip>
					) : null,
				)}

			<ButtonGroup tipChildren>
				{selectionActions &&
					selectionActions.map((action) =>
						action.name === 'Scan Remaining Pages' && !action.disabled ? (
							<Tooltip content={action.name} key={`action-${action.name}`}>
								<Button
									title={action.name}
									iconOnly={props.iconsOnly}
									icon={MailActionsIconMap[action.name]}
									colour={ColourStateSolid.Secondary}
									squared
									onClick={() =>
										props.actionCallback ? props.actionCallback(action.transitionId) : null
									}
								/>
							</Tooltip>
						) : null,
					)}

				{selectionActions &&
					selectionActions.map((action) =>
						action.name === 'Forward' && !action.disabled ? (
							<Tooltip content={action.name} key={`action-${action.name}`}>
								<Button
									title={action.name}
									iconOnly={props.iconsOnly}
									icon={MailActionsIconMap[action.name]}
									colour={ColourStateSolid.Danger}
									squared
									onClick={() =>
										props.actionCallback ? props.actionCallback(action.transitionId) : null
									}
								/>
							</Tooltip>
						) : null,
					)}

				{selectionActions &&
					selectionActions.map((action) =>
						action.name === 'Physical Store' && !action.disabled ? (
							<Tooltip content={action.name} key={`action-${action.name}`}>
								<Button
									title={action.name}
									iconOnly={props.iconsOnly}
									icon={MailActionsIconMap[action.name]}
									colour={ColourStateSolid.Danger}
									squared
									onClick={() =>
										props.actionCallback ? props.actionCallback(action.transitionId) : null
									}
								/>
							</Tooltip>
						) : null,
					)}

				{selectionActions &&
					selectionActions.map((action) =>
						action.name === 'Digital Store' && !action.disabled ? (
							<Tooltip content={action.name} key={`action-${action.name}`}>
								<Button
									title={action.name}
									iconOnly={props.iconsOnly}
									icon={MailActionsIconMap[action.name]}
									colour={ColourStateSolid.Secondary}
									squared
									onClick={() =>
										props.actionCallback ? props.actionCallback(action.transitionId) : null
									}
								/>
							</Tooltip>
						) : null,
					)}
			</ButtonGroup>

			{selectionActions &&
				selectionActions.map((action) =>
					action.name === 'Return to Sender' && !action.disabled ? (
						<Tooltip content={action.name} key={`action-${action.name}`}>
							<Button
								title={action.name}
								icon={MailActionsIconMap[action.name]}
								iconOnly={props.iconsOnly}
								colour={ColourStateSolid.Secondary}
								squared
								onClick={() =>
									props.actionCallback ? props.actionCallback(action.transitionId) : null
								}
								disabled={action.disabled}
							/>
						</Tooltip>
					) : null,
				)}

			<ButtonGroup tipChildren>
				{selectionActions &&
					selectionActions.map((action) =>
						action.name === 'Delete' && !action.disabled ? (
							<Tooltip content={action.name} key={`action-${action.name}`}>
								<Button
									title={action.name}
									iconOnly={props.iconsOnly}
									icon={MailActionsIconMap[action.name]}
									colour={ColourStateSolid.Alert}
									squared
									onClick={() =>
										props.actionCallback ? props.actionCallback(action.transitionId) : null
									}
								/>
							</Tooltip>
						) : null,
					)}
				{selectionActions &&
					selectionActions.map((action) =>
						action.name === 'Recycle' && !action.disabled ? (
							<Tooltip content={action.name} key={`action-${action.name}`}>
								<Button
									title={action.name}
									iconOnly={props.iconsOnly}
									icon={MailActionsIconMap[action.name]}
									colour={ColourStateSolid.Alert}
									squared
									onClick={() =>
										props.actionCallback ? props.actionCallback(action.transitionId) : null
									}
								/>
							</Tooltip>
						) : null,
					)}
				{selectionActions &&
					selectionActions.map((action) =>
						action.name === 'Shred' && !action.disabled ? (
							<Tooltip content={action.name} key={`action-${action.name}`}>
								<Button
									title={action.name}
									iconOnly={props.iconsOnly}
									icon={MailActionsIconMap[action.name]}
									colour={ColourStateSolid.Alert}
									squared
									onClick={() =>
										props.actionCallback ? props.actionCallback(action.transitionId) : null
									}
								/>
							</Tooltip>
						) : null,
					)}
			</ButtonGroup>

			{selectionActions &&
				selectionActions.map((action) =>
					action.name === 'Email' && !action.disabled ? (
						<Tooltip content={action.name} key={`action-${action.name}`}>
							<Button
								title={action.name}
								iconOnly
								icon={MailActionsIconMap[action.name]}
								colour={ColourStateSolid.Secondary}
								squared
								onClick={() =>
									props.actionCallback ? props.actionCallback(action.transitionId) : null
								}
							/>
						</Tooltip>
					) : null,
				)}
		</>
	) : null;
});

export default MailActionButtons;
